module.exports = __webpack_public_path__ + "static/media/seedssedang.df8e1375.png";